var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl } from "../../../utils";
import { articleRead, buyPrize, getConsumerLoyaltyProfile, getConsumerLoyaltyProfileS2S, getConsumerOrder, getConsumerPointsHistory, getConsumerRewardsCampaignsOrPrizes, getConsumerTier, getEarningRuleByName, getEarningsForConsumer, getLoyaltyPublicDomainConfiguration, getQrCodeDetails, getTiers, indexEarnings, qrCodeRead, } from "../../evo-client/__generated__";
import { convertEvoPointsHistory, getArticlesFromEvoPayload } from "./utils";
export class LoyaltyApiEvo {
    constructor(loyaltyApiUrl, loyaltyTenantToken, recaptchaId) {
        this.loyaltyTenantToken = loyaltyTenantToken;
        this.recaptchaId = recaptchaId;
        this.client = createClient(createConfig({
            baseUrl: sanitizeBaseUrl(loyaltyApiUrl),
            throwOnError: true,
        }));
    }
    getArticles(_a) {
        return __awaiter(this, arguments, void 0, function* ({ uuid, ciam_token = "" }) {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            if (!uuid) {
                const { data } = yield indexEarnings({
                    client: this.client,
                    headers: {
                        "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                        "X-DES-TENANT": this.loyaltyTenantToken,
                    },
                });
                return getArticlesFromEvoPayload(data === null || data === void 0 ? void 0 : data.data);
            }
            const { data } = yield getEarningsForConsumer({
                client: this.client,
                headers: {
                    "X-DES-USER-TOKEN": ciam_token,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-TENANT": this.loyaltyTenantToken,
                },
                path: {
                    uuid,
                },
            });
            return getArticlesFromEvoPayload(data === null || data === void 0 ? void 0 : data.data);
        });
    }
    getStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield getLoyaltyPublicDomainConfiguration({
                    client: this.client,
                    headers: {
                        "X-DES-TENANT": this.loyaltyTenantToken,
                    },
                });
                return Boolean(data === null || data === void 0 ? void 0 : data.is_active);
            }
            catch (e) {
                return false;
            }
        });
    }
    getPoints(uuid, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            const failureGetPointsResponse = {
                points: 0,
                expire_at: "",
                pending_points: 0,
                points_to_expire: 0,
            };
            try {
                const { data } = yield getConsumerLoyaltyProfile({
                    client: this.client,
                    headers: {
                        "X-DES-USER-TOKEN": ciam_token,
                        "X-DES-TENANT": this.loyaltyTenantToken,
                    },
                    path: {
                        uuid: uuid,
                    },
                });
                if (!(data === null || data === void 0 ? void 0 : data.data)) {
                    return failureGetPointsResponse;
                }
                return data.data;
            }
            catch (e) {
                return failureGetPointsResponse;
            }
        });
    }
    getEligibleCampaigns(uuid, ciam_token
    // order?: CampaignOrderData
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            // not fully implemented, could not pass the order data
            try {
                const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
                const { data } = yield getConsumerRewardsCampaignsOrPrizes({
                    client: this.client,
                    headers: {
                        "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                        "X-DES-TENANT": this.loyaltyTenantToken,
                        "X-DES-USER-TOKEN": ciam_token,
                    },
                    path: {
                        uuid,
                    },
                });
                if (!data) {
                    return [];
                }
                return data.data.map((item) => {
                    return {
                        campaign_id: item.identifier,
                        points: item.points,
                        price: item.price,
                        is_eligible: item.has_coupons,
                    };
                });
            }
            catch (e) {
                return [];
            }
        });
    }
    getPointsHistory(consumer_uuid_1, _1) {
        return __awaiter(this, arguments, void 0, function* (consumer_uuid, _, perPage = 10, page = 1) {
            const emptyGetPointsHistoryResponse = {
                items: [],
                statusCode: 400,
                total: 0,
            };
            try {
                const { data, response } = yield getConsumerPointsHistory({
                    client: this.client,
                    headers: {
                        "X-DES-TENANT": this.loyaltyTenantToken,
                    },
                    path: { uuid: consumer_uuid },
                    query: {
                        page,
                        per_page: perPage,
                    },
                });
                if (!(data === null || data === void 0 ? void 0 : data.data)) {
                    return Object.assign(Object.assign({}, emptyGetPointsHistoryResponse), { statusCode: response.status });
                }
                return convertEvoPointsHistory(data, response.status);
            }
            catch (e) {
                return emptyGetPointsHistoryResponse;
            }
        });
    }
    getTiers() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield getTiers({
                client: this.client,
                headers: {
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-TENANT": this.loyaltyTenantToken,
                },
            });
            return { data: (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [], statusCode: response.status };
        });
    }
    getUserTier(consumer_uuid, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data } = yield getConsumerTier({
                client: this.client,
                headers: {
                    "X-DES-USER-TOKEN": ciam_token,
                    "X-DES-TENANT": this.loyaltyTenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                path: {
                    uuid: consumer_uuid,
                },
            });
            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                throw new Error("No data found");
            }
            return {
                image_url: ((_a = data.data) === null || _a === void 0 ? void 0 : _a.image_url) || "",
                name: data.data.name,
            };
        });
    }
    getUserTierData(consumer_uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield getConsumerLoyaltyProfileS2S({
                client: this.client,
                headers: {
                    Authorization: recaptchaToken, // not sure if this is correct
                    "X-DES-TENANT": this.loyaltyTenantToken,
                },
                path: {
                    uuid: consumer_uuid,
                },
            });
            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                throw new Error("No data found");
            }
            return Object.assign(Object.assign({}, data.data), { statusCode: response.status });
        });
    }
    getEarnedPoints(order_id_1, ciam_token_1) {
        return __awaiter(this, arguments, void 0, function* (order_id, ciam_token, uuid = "") {
            var _a;
            const { data } = yield getConsumerOrder({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.loyaltyTenantToken,
                    "X-DES-USER-TOKEN": ciam_token,
                },
                path: {
                    order_id,
                    uuid,
                },
            });
            return ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.points) || 0;
        });
    }
    buyPrize(consumer_uuid, prize_uuid, qty, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, response } = yield buyPrize({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.loyaltyTenantToken,
                    "X-DES-USER-TOKEN": ciam_token,
                },
                path: {
                    uuid: consumer_uuid,
                },
                body: {
                    reward_uuid: prize_uuid,
                    //missing qty
                },
            });
            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                throw new Error("No data found");
            }
            return Object.assign(Object.assign({}, data.data), { statusCode: response.status, message: "" });
        });
    }
    getEarningRulePoints(event_name, _, user_uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
                const { data } = yield getEarningRuleByName({
                    client: this.client,
                    headers: {
                        "X-DES-TENANT": this.loyaltyTenantToken,
                        "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    },
                    path: {
                        event_name,
                        uuid: user_uuid,
                    },
                });
                if (!(data === null || data === void 0 ? void 0 : data.data)) {
                    return 0;
                }
                return data.data.points;
            }
            catch (e) {
                return 0;
            }
        });
    }
    getQrCodeDetails(_a) {
        return __awaiter(this, arguments, void 0, function* ({ uuid = "", qrCodeId, ciam_token = "", }) {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data } = yield getQrCodeDetails({
                client: this.client,
                headers: {
                    "X-DES-USER-TOKEN": ciam_token,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-TENANT": this.loyaltyTenantToken,
                },
                path: {
                    id: qrCodeId,
                    uuid,
                },
            });
            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                throw new Error("No data found");
            }
            return data.data;
        });
    }
    readArticleAction(article_id_1, ciam_token_1) {
        return __awaiter(this, arguments, void 0, function* (article_id, ciam_token, uuid = "") {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { response } = yield articleRead({
                client: this.client,
                headers: {
                    "X-DES-USER-TOKEN": ciam_token,
                    "X-DES-TENANT": this.loyaltyTenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                body: {
                    article_id,
                },
                path: {
                    uuid,
                },
            });
            return { statusCode: response.status };
        });
    }
    scanQrAction(qr_code_id_1, ciam_token_1) {
        return __awaiter(this, arguments, void 0, function* (qr_code_id, ciam_token, uuid = "") {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield qrCodeRead({
                client: this.client,
                headers: {
                    "X-DES-USER-TOKEN": ciam_token,
                    "X-DES-TENANT": this.loyaltyTenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                path: {
                    uuid,
                },
                body: {
                    qr_code_id,
                },
            });
            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                throw new Error("No data found");
            }
            return Object.assign(Object.assign({}, data.data), { statusCode: response.status });
        });
    }
    // NOT IMPLEMENTED METHODS IN EVO
    getPrizes(_) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject("Not implemented");
        });
    }
    getProductPoints() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject("Not implemented");
        });
    }
    getReferralHistory() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject("Not implemented");
        });
    }
    getAchievements(_userUuid, _ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject("Not implemented");
        });
    }
}
//# sourceMappingURL=LoyaltyApiEvo.js.map